import { render, staticRenderFns } from "./EducationRecords.vue?vue&type=template&id=d577ae5c&"
import script from "./EducationRecords.vue?vue&type=script&lang=js&"
export * from "./EducationRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports